
import * as React from "react";
import { observer } from "mobx-react";
import { I18nService } from "stores/i18n";
import { diResolve } from "stores/diContext";
import { AppStore } from "stores/app";


interface ILTextProps {
    bind: string;
    params?;
    tagName?: string;
    className?: string;
    style?: any;
    injectName?: string;
}

@observer
export class LText extends React.Component<ILTextProps, {}>{
    i18n: I18nService;
    app: AppStore;

    constructor(props, context) {
        super(props, context);
        this.app = diResolve("app");

        let { injectName } = this.props;
        if (!injectName) {
            injectName = "i18n";
        }
        this.i18n = diResolve(injectName);
    }

    render() {
        let language = this.app.language;
        let { bind, params, tagName, className, style, children } = this.props;
        let text = this.i18n.L(bind, params, language);
        if (!tagName) {
            tagName = "span";
        }
        if (text) {
            return React.createElement(tagName, { className, dangerouslySetInnerHTML: { __html: text }, style, data: bind, lang: language, });
        }
        return React.createElement(tagName, { className, style, data: bind, lang: language }, children);
    }
    static get(key, params?, defaultText?, injectName = "i18n") {
        var i18n: I18nService = diResolve(injectName);
        var app: AppStore = diResolve("app");
        return i18n.L(key, params, app.language) || defaultText;
    }
}


// WEBPACK FOOTER //
// ./src/Apps/shared/LText/index.tsx